import { render, staticRenderFns } from "./mainFooter.vue?vue&type=template&id=0ee1b078"
import script from "./mainFooter.vue?vue&type=script&lang=js"
export * from "./mainFooter.vue?vue&type=script&lang=js"
import style0 from "./mainFooter.vue?vue&type=style&index=0&id=0ee1b078&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports